import { createSlice } from '@reduxjs/toolkit';
import type { StaffChangePasswordInput } from '@icebreaker/shared/staff';
import { type ApiErrorBody } from '@icebreaker/shared/errors';
import { createAsyncActions, initialAsyncState, type AsyncState } from '@icebreaker/shared/store';

/**
 * PERSONEL ŞİFRESİNİ DEĞİŞTİRME (panel kimliği ayrımı · Karar 4c).
 *
 * Depo `root-reducer`ın oturum sınırında sıfırlanır, yani hesap değişince
 * önceki personelin form durumu ekranda kalamaz.
 *
 * "Şifre kurulu mu" DURUMU ARTIK TUTULMUYOR: şifresiz personel panele hiç
 * giremez (ilk şifre davet jetonuyla kurulur), dolayısıyla oturumu olan her
 * personelin şifresi VARDIR. Eskiden bu bir çalışma zamanı sorusuydu ve kapı
 * onu her açılışta sunucuya soruyordu; artık YAPISAL bir olgudur.
 */
export const changeStaffPassword = createAsyncActions<StaffChangePasswordInput, void>(
  'staffAccess/changePassword',
);

export interface StaffAccessState {
  saveState: AsyncState<ApiErrorBody>;
  /** Kaydetme başarılıysa ekranda tek seferlik onay cümlesi gösterilir. */
  saved: boolean;
}

const initialState: StaffAccessState = {
  saveState: { ...initialAsyncState },
  saved: false,
};

const slice = createSlice({
  name: 'staffAccess',
  initialState,
  reducers: {
    /** Diyalog kapanırken/açılırken önceki denemenin hatası taşınmaz. */
    passwordFormReset(state) {
      state.saveState = { ...initialAsyncState };
      state.saved = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(changeStaffPassword.request, (state) => {
        state.saveState.status = 'loading';
        state.saveState.error = null;
        state.saved = false;
      })
      .addCase(changeStaffPassword.success, (state) => {
        state.saveState.status = 'succeeded';
        state.saved = true;
      })
      .addCase(changeStaffPassword.failure, (state, action) => {
        state.saveState.status = 'failed';
        state.saveState.error = action.payload;
      });
  },
});

export const { passwordFormReset } = slice.actions;
export const staffAccessReducer = slice.reducer;
